import AppPaths from '../AppPaths';
import { miniCollarId, series3PlusCollarId, ultraCollarId } from '../types';

const DEVICE_BY_COLLAR_ID: Record<string, 'mini' | 's3' | 'ultra'> = {
  [miniCollarId]: 'mini',
  [series3PlusCollarId]: 's3',
  [ultraCollarId]: 'ultra',
};

/**
 * Where a collar pdp sends an enrolled visitor: the shop with that device preselected. The query
 * string rides along, so campaign params and `?type=cat` survive the hop. Undefined for every other
 * product (bands, bases, supplements), which keep their pages.
 */
export function shopPathForCollarPdp(productId: string, search: string): string | undefined {
  const device = DEVICE_BY_COLLAR_ID[productId];
  if (!device) {
    return undefined;
  }
  const params = new URLSearchParams(search);
  params.set('selected', device);
  return `${AppPaths.Shop}?${params.toString()}`;
}

/**
 * Where a codeless redeem page sends an enrolled visitor: the shop with its device preselected and the
 * query string kept, so campaign params and `?type=cat` survive. Redeem pages with a code never get
 * here; the partner context keeps them on the classic flow.
 */
export function shopPathForCodelessRedeem(pathname: string, search: string): string {
  const params = new URLSearchParams(search);
  params.set('selected', pathname === AppPaths.MiniRedeem ? 'mini' : 's3');
  return `${AppPaths.Shop}?${params.toString()}`;
}
